import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Flyer from "@/pages/Flyer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { Toaster } from "sonner";
import { CookieConsent } from "@/components/CookieConsent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/flyer" element={<Flyer />} />
          <Route path="/integritetspolicy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
